import { render } from "./SuKwsWeatherIcon.vue?vue&type=template&id=36f8178a"
import script from "./SuKwsWeatherIcon.vue?vue&type=script&lang=js"
export * from "./SuKwsWeatherIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__